


export function saveAddress(data, storage){

    // BUSCA OS DADOS DA LISTA DE ENDEREÇOS NO CACHE
    const resAddressList = storage.get('ADDRESS_LIST');

    // INSTANCIA A LISTA
    const list = resAddressList && resAddressList.length > 0 ? [...resAddressList ?? resAddressList] : [];

    const dAddress = data.deliveryAddress;

    // BUSCA UM REGISTRO JÁ EXISTENTE COM O MESMO CEP+NÚMERO OU MESMO TELEFONE
    const matchIndex = list.findIndex((item) => {
        const itemAddress = item.deliveryAddress ?? {};

        const sameAddress = (
            itemAddress.postalCode == dAddress.postalCode &&
            itemAddress.number == dAddress.number
        );
        const samePhone = item.phone == data.phone;

        return sameAddress || samePhone;
    });

    const updatedEntry = {
        name: data.name,
        phone: data.phone,
        phoneHint: data.phone ? `****${String(data.phone).slice(-4)}` : null,
        document: data.document ?? null,
        deliveryAddress: dAddress,
        createdAt: matchIndex >= 0 ? list[matchIndex].createdAt : Date.now(),
    };

    // CASO JÁ EXISTA, ATUALIZA OS DADOS DO REGISTRO. CASO CONTRÁRIO, INSERE UM NOVO
    if(matchIndex >= 0){
        list[matchIndex] = updatedEntry;

    } else {
        list.push(updatedEntry);
    }

    // SALVA ENDEREÇO DE ENTREGA NO CACHE DO NAVEGADOR
    // storage.saveWithTTL('ADDRESS_LIST', list, 43200);
    storage.save('ADDRESS_LIST', list);

    return;
}
